import React, { FC } from 'react'
import {
  Autocomplete,
  Card,
  Typography,
  Box,
  Button,
  TextField,
  useMediaQuery,
  Link,
} from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import { useReservationsTable } from './useReservationTable'
import { TableSearch } from '../../../shared/TableSearch'
import { useTheme } from '../../../../utils/themeContext'
import { getColorsForTheme } from '../../../../global-styles/clientColors'

export const ReservationTable: FC = () => {
  const isDesktop = useMediaQuery('(min-width:1400px)')

  const {
    reservations,
    total,
    page,
    rowsPerPage,
    setPaginationModel,
    isLoading,
    setQuery,
    programs,
    search,
    setProgram,
  } = useReservationsTable()

  const { currentTheme } = useTheme()
  const themeColors = getColorsForTheme(currentTheme)

  const columns = [
    {
      field: 'customerName',
      headerName: 'Customer Name',
      cellClassName: 'primaryAccent',
      flex: 1,
      renderCell: (props) => (
        <Link
          sx={{
            fontWeight: 'bold',
            color: themeColors.buttonColor,
            '&:hover': {
              color: themeColors.buttonHover,
            },
          }}
          href={`/customers/${props.row.customerId}`}
        >
          {props?.row?.customerName?.trim()
            ? props?.row?.customerName
            : '{blank}'}
        </Link>
      ),
    },
    {
      field: 'accountNumber',
      headerName: 'Account Number',
      flex: 0.75,
    },
    {
      field: 'make',
      headerName: 'Make',
      flex: 0.5,
    },
    {
      field: 'model',
      headerName: 'Model',
      flex: 0.5,
    },
    {
      field: 'waitlistStart',
      headerName: 'Start Date',
      flex: 0.75,
    },
    {
      field: 'color',
      headerName: 'Color Preferences',
      flex: 0.75,
    },
    {
      field: 'zipcode',
      headerName: 'ZIP Code',
      flex: 0.5,
    },
    {
      field: 'status',
      headerName: 'Reservation Status',
      flex: 1,
    },
    {
      field: 'vehicleDetail',
      headerName: '',
      flex: 1,
      renderCell: (props) => (
        <Link
          href={`/reservations/${props.row.reservationId}`}
          sx={{
            fontWeight: 'bold',
            color: themeColors.buttonColor,
            '&:hover': {
              color: themeColors.buttonHover,
            },
            textDecoration: 'none',
          }}
        >
          <Button sx={{
            backgroundColor: themeColors.buttonColor,
            color: currentTheme === 'galpin' ? 'black' : 'white',
            '&:hover': {
              backgroundColor: themeColors.buttonHover,
            },
          }}
                  variant="contained">
            {isDesktop ? 'View Reservation' : 'View'}
          </Button>
        </Link>
      ),
    },
  ]

  return (
    <Box
      sx={{
        backgroundColor: 'background.default',
        p: 3,
      }}
    >
      <Typography sx={{ marginLeft: '5px' }} variant="h1">
        Reservations
      </Typography>
      <Card>
        <Box sx={{ display: 'flex', flexDirection: 'row' }}>
          <TableSearch
            label="Search by account number"
            setQuery={setQuery}
            search={search}
          />
          <Autocomplete
            sx={{ width: '100%', paddingRight: '10px', marginTop: '-8px' }}
            disableClearable
            options={[
              { id: undefined, description: 'All Programs' },
              ...(Array.isArray(programs?.programsList) ? programs.programsList : []),
            ]}
            getOptionLabel={(option) => option.description}
            renderInput={(inputProps) => (
              <TextField
                {...inputProps}
                label="All Programs"
                margin="normal"
                variant="outlined"
              />
            )}
            onChange={(e, value) => setProgram(value.id)}
          />
        </Box>
        <DataGrid
          columns={columns}
          rows={reservations}
          rowCount={total}
          paginationModel={{page: page, pageSize: rowsPerPage}}
          autoHeight
          loading={isLoading}
          paginationMode="server"
          onPaginationModelChange={(newPaginationModel) => setPaginationModel(newPaginationModel)}
        />
        {/* </Grid> */}
      </Card>
    </Box>
  )
}
